import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faUserCircle,
  faFilter,
  faSearch,
  faBookOpen,
  faAtom,
  faCaretUp,
  faCaretDown,
  faPalette,
  faCommentMedical,
  faWind,
  faSplotch,
  faTimes,
  faFilePdf,
  faArrowUp,
  faArrowDown,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// General
library.add(faUserCircle, faFilter, faSearch, faBookOpen, faAtom)
// Collapse
library.add(faCaretUp, faCaretDown)
// Observations
library.add(faPalette, faCommentMedical, faWind, faSplotch, faTimes)
// Guides
library.add(faFilePdf)
// Table
library.add(faArrowUp, faArrowDown)

export default {
  install: (Vue, options) => {
    Vue.component('font-awesome-icon', FontAwesomeIcon)
  }
}
